(() => {
  'use strict';
  const variantId = (href) => {
    const id = new URL(href).searchParams.get('variant') || '';
    return /^\d{1,20}$/.test(id) ? `gid://shopify/ProductVariant/${id}` : null;
  };
  const localizationRequest = (href, currentLanguage, alternateHref) => {
    const url = new URL(href);
    const language = url.searchParams.get('carron_alert_lang');
    if (!['fr', 'en'].includes(language) || language === currentLanguage || url.searchParams.has('carron_alert_localized')) return null;
    const alternate = alternateHref ? new URL(alternateHref, url) : null;
    if (!url.pathname.includes('/apps/') && alternate?.origin === url.origin) url.pathname = alternate.pathname;
    url.searchParams.set('carron_alert_localized', '1');
    return { language, returnTo: url.pathname + url.search + url.hash };
  };
  const loginUrl = (href) => {
    const current = new URL(href);
    const login = new URL('/customer_authentication/login', current.origin);
    login.searchParams.set('return_to', current.pathname + current.search + current.hash);
    return login.href;
  };
  const pageUrl = (href, collectionPath, variant) => {
    const current = new URL(href);
    if (!variant || !Number.isInteger(variant.productPage) || variant.productPage < 1 || current.searchParams.has('carron_alert_page')) return null;
    const productId = String(variant.productId).split('/').pop();
    if (!/^\d+$/.test(productId)) return null;
    const target = new URL(collectionPath, current.origin);
    if (target.origin !== current.origin) return null;
    target.search = current.search;
    for (const key of [...target.searchParams.keys()]) {
      if (key.startsWith('filter.') || ['sort_by', 'q', 'section_id'].includes(key)) target.searchParams.delete(key);
    }
    target.searchParams.set('page', String(variant.productPage));
    target.searchParams.set('carron_alert_page', '1');
    target.hash = `wholesale-product-${productId}`;
    return target.href;
  };
  const browseUrl = (href) => {
    const url = new URL(href);
    url.searchParams.delete('variant');
    url.searchParams.delete('carron_alert_page');
    if (url.hash.startsWith('#wholesale-product-')) url.hash = '';
    return url;
  };
  window.CarronAlertLinks = { variantId, localizationRequest, loginUrl, pageUrl, browseUrl };
  const initialize = () => {
    const url = new URL(window.location.href);
    const language = url.searchParams.get('carron_alert_lang');
    if (!['fr', 'en'].includes(language)) return;
    const alternate = document.querySelector(`link[rel="alternate"][hreflang="${language}"]`);
    const request = localizationRequest(url.href, document.documentElement.lang, alternate?.href);
    if (request) {
      const form = document.createElement('form');
      form.method = 'post';
      form.action = '/localization';
      form.hidden = true;
      for (const [name, value] of Object.entries({ form_type: 'localization', utf8: '✓', _method: 'put', language_code: request.language, return_to: request.returnTo })) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = name; input.value = value; form.append(input);
      }
      document.body.append(form);
      form.submit();
      return;
    }
    if (variantId(url.href)) {
      document.querySelectorAll('.carron-preorder-access__actions a[href*="login"]').forEach((link) => {
        link.href = loginUrl(url.href);
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
